import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c('loading'),_c(VMain,{class:[`white`]},[_c('router-view'),_c('alert',{attrs:{"type":_vm.errorType,"message":_vm.errorMessage},model:{value:(_vm.showError),callback:function ($$v) {_vm.showError=$$v},expression:"showError"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }